var topHeader = $(".template-index .Header")
$(window).on('scroll load', function () {
  var y = window.pageYOffset;
  if (y == 0) {
    topHeader.addClass('header_top_hover');
  } else {
    topHeader.removeClass('header_top_hover');
  }
});

// inview.js
$(function () {
  $(".js-inview").on("inview", function () {
    $(this).addClass("active");
  });
});